import React, {useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import {categories, metrics} from '../data/metrics';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  const getPageTitle = () => {
    if (location.pathname === '/') return 'Dashboard';

    const categoryMatch = location.pathname.match(/\/category\/([^/]+)/);
    if (categoryMatch) {
      const cat = categories.find(c => c.id === categoryMatch[1]);
      return cat ? cat.name : 'Category';
    }

    const calculatorMatch = location.pathname.match(/\/calculator\/([^/]+)/);
    if (calculatorMatch) {
      const met = metrics.find(m => m.id === calculatorMatch[1]);
      return met ? 'Calculator' : 'Calculator';
    }

    return 'Metrics Calculator';
  };

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />
      
      <div className="flex-1 flex flex-col min-w-0">
        <Header
          toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          title={getPageTitle()}
        />
        
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 custom-scrollbar">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;